import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
// import Navbar from '../../pages/navbar'
import Footer from '../../pages/footer'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { useWindowScrollPositions } from '../../assets/components/ScrollPosition'
import { useController } from '../../assets/components/BaseContrroler'
import Navbar from './Navbar'
import { AppBar } from '@mui/material'
import { observer } from 'mobx-react-lite'





function Baselayout() {
    const { baseController: { homeController } } = useController()
    const { isNavbarOpen, setNavbar, url, setUrl } = homeController
    const { scrollX, scrollY } = useWindowScrollPositions()


    useEffect(() => {
        const navControle = () => {
            if (scrollY <= 400 && (url === '/' || url === '' || url === null)) {
                setNavbar(false)
            } else {
                setNavbar(true)
            }
            console.log(isNavbarOpen, url)
        }
        navControle()
    })



    return (
        <>
            <div className={isNavbarOpen ? 'navb fade-out' : 'navb fade-in'} id='navBar'>
                <AppBar className='navb' id='navBar'>
                    <Navbar />
                    {/* <Navbar /> */}
                </AppBar >
            </div >
            <div className='container-fluid'>
                <FloatingWhatsApp
                    phoneNumber='+8801732850650'
                    accountName='Karnafully'
                    avatar={require('../../assets/images/logo.png')}
                    allowEsc
                    allowClickAway
                    notification
                    notificationSound
                />
                <Outlet />
                <Footer />
            </div>
        </>
    )
}

export default observer(Baselayout)